import React from 'react';

import forbes from '@hydra/assets/img/signup/forbes.svg';
import godaddy from '@hydra/assets/img/signup/godaddy.svg';
import hubspot from '@hydra/assets/img/signup/hubspot.svg';
import salesforce from '@hydra/assets/img/signup/salesforce.svg';
import sej from '@hydra/assets/img/signup/sej.svg';
import sel from '@hydra/assets/img/signup/sel.svg';
import smartInsight from '@hydra/assets/img/signup/smart-insight.svg';
import spartktoro from '@hydra/assets/img/signup/spartktoro.svg';

import { Image, Translate } from '@hydra/common/components';
import { Grid } from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  title: {
    textAlign: 'center',
    fontSize: theme.typography.fontSizeLarge,
    marginBottom: theme.spacing(3)
  },
  imgContainer: {
    marginBottom: theme.spacing(2)
  },
  imageGrid: {
    textAlign: 'center'
  }
}));

function ImageGrid ({ src }: { src: string }) {
  const classes = useStyles();
  return (
    <Grid className={classes.imageGrid} item xs={6} sm={3}>
      <Image src={src} />
    </Grid>
  );
}

export default function FeaturedIn () {
  const classes = useStyles();
  return (
    <>
      <Translate content='hydra_signup_featured_in' component='div' className={classes.title} />
      <div className={classes.imgContainer}>
        <Grid container spacing={3}>
          <ImageGrid src={hubspot} />
          <ImageGrid src={sel} />
          <ImageGrid src={sej} />
          <ImageGrid src={spartktoro} />
        </Grid>
        <Grid container spacing={3}>
          <ImageGrid src={smartInsight} />
          <ImageGrid src={salesforce} />
          <ImageGrid src={godaddy} />
          <ImageGrid src={forbes} />
        </Grid>
      </div>
    </>
  );
}
